import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';
import * as moment from 'moment';
import { Chart } from 'chart.js';

/**
 * Generated class for the TachogramlivePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tachogramlive',
  templateUrl: 'tachogramlive.html',
})
export class TachogramlivePage {
  loadingData: boolean = true
  priv: boolean = false
  startDate: any
  endDate: any
  nowTime: any
  vehicles = []
  ReportData = []
  HaveWorkTime = 0
  period = ''
  period1 = ''
  momentalenDatum: any
  end = 0
  intervals = []
  diffdays = -1
  dataCards = []
  dataTimeRel = []

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN) {
    this.startDate = moment(new Date()).format('YYYY-MM-DD');//moment('2020-03-24').format('YYYY-MM-DD');//
    this.endDate = moment(new Date()).format('YYYY-MM-DD');//moment('2020-03-24').format('YYYY-MM-DD');
    this.nowTime = moment(new Date()).format('HH:mm:ss');//moment('2020-03-24').format('HH:mm:ss');
    this.vehicles.push(navParams.get('vid'));
    this.gn.xlsFunction = null
    this.period = moment(this.startDate).format('DD-MM-YYYY 00:00:00') + ' - ' + moment(this.endDate).format('DD-MM-YYYY 23:59:59');
    this.period1 = moment(this.startDate).format('DD-MM-YYYY') + ' - ' + moment(this.endDate).format('DD-MM-YYYY');
    this.momentalenDatum = moment(this.momentalenDatum).format(this.gn.user.DFormat) + ' ' + moment(this.momentalenDatum).format(this.gn.user.TFormat)
  }

  ionViewDidLoad() {
    if (this.gn.Vehicles[0] == undefined) {
      this.loadingData = false;
      this.priv = true;
      return false;
    }

    if (this.startDate != null) {
      if (this.vehicles.length == 1) {
        //alert(this.vehicles[0])
        if (this.vehicles[0] + '' == '0') {
          this.vehicles = []
          for (var i = 0; i < this.gn.Vehicles.length; i++) {
            this.vehicles.push(this.gn.Vehicles[i].vehicleid)
          }
        }
      }
      this.loadData()
    }
  }

  sec2str(_sec) {
    return moment.utc(_sec * 1000).format('HH:mm:ss');
  }
  sec2str2(_sec) {
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      // console.log("sec2str2")  
      return str;
    }
    else {
      return -1;
    }
  }

  loadData() {
    var logvozila = this.gn.getVehiclesLog(this.vehicles);
    var logperiod = 'Период од: ' + moment(this.startDate).format('DD-MM-YYYY 00:00:00') + ' до: ' + moment(this.endDate).format('DD-MM-YYYY 23:59:59');
    //this.gn.addLog(15, logperiod + ' за возилата: ' + logvozila);

    // console.log(this.startDate, this.endDate, this.vehicles, this.reportType)
    this.ReportData = []
    this.loadingData = true
    this.priv = true;//this.gn.getPriv('overview')

    var _that = this


    var start1 = moment(this.startDate, "YYYY-MM-DD");
    var end1 = moment(this.endDate, "YYYY-MM-DD");
    this.diffdays = moment.duration(end1.diff(start1)).asDays();

    if (this.diffdays == 0) {
      var int = 0;
      for (var i = 0; i <= 8; i++) {
        this.intervals.push({ val: int, left: 'calc(' + (100 / 8 * i) + '% - ' + ((i * 20) + 10) + 'px)' })
        int = int + 3;
      }
    } else {
      var int = 0;
      for (var i = 0; i <= (this.diffdays + 1); i++) {
        //tmpsd.format('DD') + ' ' + _that.dic.l[tmpsd.format('MMMM')]
        var tmpd = moment(this.startDate).add(i, 'days')
        var tmpd1 = tmpd.format('DD') + ' ' + this.dic.l[tmpd.format('MMMM')]
        this.intervals.push({ val: tmpd1, left: 'calc(' + (100 / (this.diffdays + 1) * i) + '% - ' + ((i * 20) + 10) + 'px)', width: (100 / (this.diffdays + 1)) + '%' })
        int = int + 3;
      }
    }
    //debugger

    for (var vv = 0; vv < _that.vehicles.length; vv++) {
      var tmpend = 0;
      if (vv == (this.vehicles.length - 1)) tmpend = 1;
      var _dat = {
        uid: this.gn.crypt(this.gn.user.UserId),
        cid: this.gn.crypt(this.gn.user.ClientId),
        rid: this.gn.crypt(this.gn.user.RoleId),
        sd: this.gn.crypt(this.startDate),
        ed: this.gn.crypt(this.endDate),
        vid: this.gn.crypt(this.vehicles[vv]),
        endfor: this.gn.crypt(tmpend)
      }

      var _that = this
      this.gn._Post('/api/gn/reports/tachogram', _dat, function (_data) {

        var _vehicleid = _data.vid
        var _allowtacho = _data.allowtacho
        _that.end = _data.end
        _that.dataCards = _data.datac
        _that.dataTimeRel = _data.datatr

        _data = _data.data
        if (_data[1] != undefined && _data[0].drivercard == _data[1].drivercard && _data[0].driverstate == _data[1].driverstate) {
          _data.splice(1, 1);
        }

        for (let i = 0; i < _that.gn.Vehicles.length; i++) {
          if (_vehicleid == _that.gn.Vehicles[i].vehicleid) {

            var _orgname = ''
            if (_that.gn.Vehicles[i].organisationid == 0) {
              _orgname = _that.dic.l['Ungroupped']
            } else {
              for (let j = 0; j < _that.gn.Organisations.length; j++) {
                if (_that.gn.Vehicles[i].organisationid == _that.gn.Organisations[j].id && _that.gn.Vehicles[i].organisationid != 0) {
                  _orgname = _that.gn.Organisations[j].name;
                }
              }
            }

            var _dataDT = [];
            var _dataAct = [];

            // if(i==0) {
            //   _dataDT = ['2020-03-11 00:00:00', '2020-03-11 04:30:00', '2020-03-11 07:30:00', '2020-03-11 12:15:00', '2020-03-11 15:40:00', '2020-03-11 18:30:00', '2020-03-11 20:00:00', '2020-03-11 22:40:00']
            //   _dataAct = ['-1', '0', '1', '3', '1', '2', '3', '0']
            // } else {
            //   _dataDT = ['2020-03-11 00:00:00', '2020-03-11 02:15:00', '2020-03-11 07:00:00', '2020-03-11 11:00:00', '2020-03-11 16:00:00', '2020-03-11 18:00:00', '2020-03-11 19:00:00', '2020-03-11 20:00:00', '2020-03-11 22:00:00']
            //   _dataAct = ['-1', '0', '1', '3', '2', '1', '2', '3', '0']
            // }

            var _sumTacho0 = 0;
            var _sumTacho1 = 0;
            var _sumTacho2 = 0;
            var _sumTacho3 = 0;
            var _sumTacho6 = 0;
            var _sumTacho7 = 0;

            var date1;
            var date2;
            var startDt;
            var endDt;

            for (var k = 0; k < _data.length; k++) {
              _dataDT.push({ dt: _data[k].datetime, dt1: _data[k].datetime1, dtformatted: moment(_data[k].datetime).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) })
              _dataAct.push({ drivercard: _data[k].drivercard, act: _data[k].driverstate + '', actdesc: _that.dic.l['tachodesc' + _data[k].driverstate], actduration: 0 })
            }

            for (var d = 0; d < _dataDT.length; d++) {
              var duration;
              if (d == _dataDT.length - 1) {
                startDt = moment(_dataDT[d].dt).format(_that.gn.user.TFormat)
                if (moment(_dataDT[d].dt).format('HH:mm:ss') == '00:00:00') {
                  startDt = moment(_dataDT[d].dt1).format(_that.gn.user.TFormat + ' ' + _that.gn.user.DFormat)
                }
                date1 = moment(_dataDT[d].dt)
                date2 = moment(moment(_dataDT[d].dt).format('YYYY-MM-DD ' + _that.nowTime))
                endDt = '/'

                duration = moment.duration(date2.diff(date1));
              } else {
                startDt = moment(_dataDT[d].dt).format(_that.gn.user.TFormat)
                date1 = moment(_dataDT[d].dt)
                date2 = moment(_dataDT[d + 1].dt);
                endDt = date2.format(_that.gn.user.TFormat)

                duration = moment.duration(date2.diff(date1));
              }
              var durationH = duration.asHours();

              if (_dataAct[d].act == '0') _sumTacho0 += durationH
              if (_dataAct[d].act == '1') _sumTacho1 += durationH
              if (_dataAct[d].act == '2') _sumTacho2 += durationH
              if (_dataAct[d].act == '3') _sumTacho3 += durationH
              if (_dataAct[d].act == '6') _sumTacho6 += durationH
              if (_dataAct[d].act == '7') _sumTacho7 += durationH


              var durationMTachoTmp = (durationH - parseInt(durationH + '')) * 60
              var _durationTachoTmp = '';
              if ((d == 0 && moment(_dataDT[d].dt).format('HH:mm:ss') == '00:00:00') || d == (_dataDT.length - 1)) {
                startDt = moment(_dataDT[d].dt1).format(_that.gn.user.TFormat + ' ' + _that.gn.user.DFormat)
                _durationTachoTmp += '>'
              }
              _durationTachoTmp += (parseInt(durationH + '') + 'h ' + parseInt(durationMTachoTmp + '') + 'min');
              _dataAct[d].actduration = _durationTachoTmp
            }

            var durationMTacho0 = (_sumTacho0 - parseInt(_sumTacho0 + '')) * 60
            var _durationTacho0Final = (parseInt(_sumTacho0 + '') + 'h ' + parseInt(durationMTacho0 + '') + 'min');

            var durationMTacho1 = (_sumTacho1 - parseInt(_sumTacho1 + '')) * 60
            var _durationTacho1Final = (parseInt(_sumTacho1 + '') + 'h ' + parseInt(durationMTacho1 + '') + 'min');

            var durationMTacho2 = (_sumTacho2 - parseInt(_sumTacho2 + '')) * 60
            var _durationTacho2Final = (parseInt(_sumTacho2 + '') + 'h ' + parseInt(durationMTacho2 + '') + 'min');

            var durationMTacho3 = (_sumTacho3 - parseInt(_sumTacho3 + '')) * 60
            var _durationTacho3Final = (parseInt(_sumTacho3 + '') + 'h ' + parseInt(durationMTacho3 + '') + 'min');

            var durationMTacho6 = (_sumTacho6 - parseInt(_sumTacho6 + '')) * 60
            var _durationTacho6Final = (parseInt(_sumTacho6 + '') + 'h ' + parseInt(durationMTacho6 + '') + 'min');

            var durationMTacho7 = (_sumTacho7 - parseInt(_sumTacho7 + '')) * 60
            var _durationTacho7Final = (parseInt(_sumTacho7 + '') + 'h ' + parseInt(durationMTacho7 + '') + 'min');

            _that.ReportData.push({
              vid: _vehicleid,
              sumtacho0: _durationTacho0Final,
              sumtacho1: _durationTacho1Final,
              sumtacho2: _durationTacho2Final,
              sumtacho3: _durationTacho3Final,
              sumtacho6: _durationTacho6Final,
              sumtacho7: _durationTacho7Final,

              registration: _that.gn.Vehicles[i].registration,
              code: _that.gn.Vehicles[i].code,
              alias: _that.gn.Vehicles[i].alias,
              brand: _that.gn.Vehicles[i].brand,
              orgname: _orgname,
              period: _that.period,
              period1: _that.period1,
              momentdate: _that.momentalenDatum,
              dataDT: _dataDT,
              dataAct: _dataAct,
              allowtacho: _allowtacho
              // driver: _driver

            })

            setTimeout(function () {
              if (_that.end + "" == "1") {
                _that.loadingData = false
                for (var r = 0; r < _that.ReportData.length; r++) {
                  _that.initChartArea(_that.ReportData[r].vid, _that.ReportData[r].dataDT, _that.ReportData[r].dataAct, _that.dataCards, _that.dataTimeRel)
                }
              }
            }, 1000)
          }
        }

      })


      // var _orgname = ''
      // if (_that.gn.Vehicles[vv].organisationid == 0) {
      //   _orgname = _that.dic.l['Ungroupped']
      // } else {
      //   for (let j = 0; j < _that.gn.Organisations.length; j++) {
      //     if (_that.gn.Vehicles[vv].organisationid == _that.gn.Organisations[j].id && _that.gn.Vehicles[vv].organisationid != 0) {
      //       _orgname = _that.gn.Organisations[j].name;
      //     }
      //   }
      // }


      // 0 - rest; 1 - availability; 2 - work; 3 - driving

      // _that.gn.xlsFunction = function () {
      //   _that.createXLS()
      // }
    }





  }

  Round(_txt) {
    return parseInt(_txt + '')
  }

  RoundFloat(_txt) {
    return parseFloat(parseFloat(_txt + '').toFixed(1));
  }

  RoundFloatCeil(_txt) {
    return Math.ceil(parseFloat(_txt + ''));
  }

  initChartArea(_vid, _dataDT, _dataAct, _dataCards, _dataTimeRel) {
    //this.loadingData = false
    var ismobile = (<HTMLElement>document.getElementById('mob-footer')).offsetHeight != 0
    if (!ismobile) {
      var areaCanvas = document.getElementById('areaLive' + _vid)
    } else {
      var areaCanvas = document.getElementById('areaLiveMobile' + _vid)
    }

    if (areaCanvas != null) {
      var start = moment(this.startDate, "YYYY-MM-DD");
      var end = moment(this.endDate, "YYYY-MM-DD");
      var _diffdays = moment.duration(end.diff(start)).asDays();
      var _totalsec = 86400 * (_diffdays + 1)

      //▲▼
      var _html = ``
      for (var c = 0; c < _dataCards.length; c++) {
        var _tmpTimeCard = moment(_dataCards[c].datetime).format('HH:mm:ss')
        var _timeSecCard = moment.duration(_tmpTimeCard).asSeconds()
        var _leftCard = _timeSecCard / (86400 / 100)
        var _icon = ''
        var _top = 0
        var _title = ''
        var _both = 0;

        if (_dataCards[c].changed1 == 'true') {
          if (_dataCards[c].d1card == '1') { _icon = '▲'; _title = _tmpTimeCard + '&#13;' + this.dic.l["tachoin1"] }
          else if (_dataCards[c].d1card == '0') { _icon = '▼'; _top = 3; _title = _tmpTimeCard + '&#13;' + this.dic.l["tachoout1"] }
          _html += `
            <div style="position: absolute; top: 0px;  width:2px; text-align: center; color: #000; z-index: 99998; border-right: 2px solid #000; height: 100%;left: ` + _leftCard + `%;" title="` + _title + `"></div>
            <div style="position: absolute; top: `+ _top + `px;  width: 40px; text-align: center; color: #000; z-index: 99998;height: 100%;left: calc(` + _leftCard + `% - 13px);font-size: 10px;" title="` + _title + `">` + _icon + `#1</div>
          `
          if (_dataCards[c].changed2 == 'true' && (_dataCards[c].d2card == '1' || _dataCards[c].d2card == '0')) {
            _both = 1;
            _top = 15
          }
        }
        if (_dataCards[c].changed2 == 'true') {
          if (_dataCards[c].d2card == '1') {
            _icon = '▲'
            if (_both == 1) {
              _title += '&#13;' + this.dic.l["tachoin2"];// + ' (' + _tmpTimeCard + ')'
            } else {
              _title = _tmpTimeCard + '&#13;' + this.dic.l["tachoin2"]
            }
          }
          else if (_dataCards[c].d2card == '0') {
            _icon = '▼';
            if (_both == 1) {
              _title += '&#13;' + this.dic.l["tachoout2"];// + ' (' + _tmpTimeCard + ')'
            } else {
              _top = 3;
              _title = _tmpTimeCard + '&#13;' + this.dic.l["tachoout2"]
            }
          }
          _html += `
            <div style="position: absolute; top: 0px;  width:2px; text-align: center; color: #000; z-index: 99998; border-right: 2px solid #000; height: 100%;left: ` + _leftCard + `%;" title="` + _title + `"></div>
            <div style="position: absolute; top: `+ _top + `px;  width: 40px; text-align: center; color: #000; z-index: 99998;height: 100%;left: calc(` + _leftCard + `% - 13px);font-size: 10px;" title="` + _title + `">` + _icon + `#2</div>
          `
        }
        //debugger

      }


      //TimeRelState
      for (var c = 0; c < _dataTimeRel.length; c++) {
        var _tmpTimeRel = moment(_dataTimeRel[c].datetime).format('HH:mm:ss')
        var _tmpTimeRel1 = moment(_dataTimeRel[c].datetime).format(this.gn.user.DFormat)
        var _timeSecTimeRel = moment.duration(_tmpTimeRel).asSeconds()
        var _leftTimeRel = _timeSecTimeRel / (_totalsec / 100)
        var _icon = '⚠️';//'⚠';// '⚠️';
        var _title = ''
        var _both = 0;
        var _borderColor = 'solid #000000'
        if (_dataTimeRel[c].changed1 == 'true') {
          _title = _tmpTimeRel + ' ' + _tmpTimeRel1 + '&#13;' + this.dic.l["driver1"] + ': ' + this.dic.l["tachotimerel" + _dataTimeRel[c].d1timerelstate]
          if (_dataTimeRel[c].d1timerelstate + '' == '1') _borderColor = 'solid #9fff80'
          if (_dataTimeRel[c].d1timerelstate + '' == '2') _borderColor = 'solid #2db300'
          if (_dataTimeRel[c].d1timerelstate + '' == '3') _borderColor = 'solid #c44dff'
          if (_dataTimeRel[c].d1timerelstate + '' == '4') _borderColor = 'solid #8800cc'
          if (_dataTimeRel[c].d1timerelstate + '' == '5') _borderColor = 'solid #4da6ff'
          if (_dataTimeRel[c].d1timerelstate + '' == '6') _borderColor = 'solid #0073e6'
          if (_dataTimeRel[c].d1timerelstate + '' == '7') _borderColor = 'solid #00cccc'
          if (_dataTimeRel[c].d1timerelstate + '' == '13') _borderColor = 'solid #8c8c8c'
          if (_dataTimeRel[c].d1timerelstate + '' == '14') _borderColor = 'solid #ac3939'
          if (_dataTimeRel[c].d1timerelstate + '' == '15') _borderColor = 'solid #ffff00'
        }
        if (_dataTimeRel[c].changed2 == 'true') {
          _title = _tmpTimeRel + ' ' + _tmpTimeRel1 + '&#13;' + this.dic.l["driver2"] + ': ' + this.dic.l["tachotimerel" + _dataTimeRel[c].d2timerelstate]
          if (_dataTimeRel[c].d2timerelstate + '' == '1') _borderColor = 'solid #9fff80'
          if (_dataTimeRel[c].d2timerelstate + '' == '2') _borderColor = 'solid #2db300'
          if (_dataTimeRel[c].d2timerelstate + '' == '3') _borderColor = 'solid #c44dff'
          if (_dataTimeRel[c].d2timerelstate + '' == '4') _borderColor = 'solid #8800cc'
          if (_dataTimeRel[c].d2timerelstate + '' == '5') _borderColor = 'solid #4da6ff'
          if (_dataTimeRel[c].d2timerelstate + '' == '6') _borderColor = 'solid #0073e6'
          if (_dataTimeRel[c].d2timerelstate + '' == '7') _borderColor = 'solid #00cccc'
          if (_dataTimeRel[c].d2timerelstate + '' == '13') _borderColor = 'solid #8c8c8c'
          if (_dataTimeRel[c].d2timerelstate + '' == '14') _borderColor = 'solid #ac3939'
          if (_dataTimeRel[c].d2timerelstate + '' == '15') _borderColor = 'solid #ffff00'
        }

        if (_dataTimeRel[c].changed1 == 'true') {
          _title = _tmpTimeRel + ' ' + _tmpTimeRel1 + '&#13;' + this.dic.l["driver1"] + ': ' + this.dic.l["tachotimerel" + _dataTimeRel[c].d1timerelstate]
        }
        if (_dataTimeRel[c].changed2 == 'true') {
          _title = _tmpTimeRel + ' ' + _tmpTimeRel1 + '&#13;' + this.dic.l["driver2"] + ': ' + this.dic.l["tachotimerel" + _dataTimeRel[c].d2timerelstate]
        }
        // _html += `
        //   <div style="position: absolute; top: 0px;  width:2px; text-align: center; color: #000; z-index: 99999; border-right: 2px dashed #000; height: 100%;left: ` + _leftTimeRel + `%; title="` + _title + `"></div>
        // `
        _html += `
          <div style="position: absolute; top: 0px;  width:2px; text-align: center; color: #000; z-index: 99999; border-right: 2px `+ _borderColor + `; height: 100%;left: ` + _leftTimeRel + `%; title="` + _title + `"></div>
          <div style="position: absolute; top: calc(100% - 20px);  width: 40px; text-align: center; color: #000; z-index: 99999;height: 100%;left: calc(` + _leftTimeRel + `% - 19px);font-size: 14px; text-shadow:0 0 2px #000" title="` + _title + `">` + _icon + `</div>
        `
        // _html += `
        //   <div style="position: absolute; top: 0px;  width:2px; text-align: center; color: #000; z-index: 99999; border-right: 2px solid #000; height: calc(100% - 16px);left: ` + _leftTimeRel + `%; title="` + _title + `"></div>
        //   <div style="position: absolute; top: calc(100% - 25px);  width: 40px; text-align: center; color: #000; z-index: 99999;height: 100%;left: calc(` + _leftTimeRel + `% - 19px);font-size: 24px;" title="` + _title + `">` + _icon + `</div>
        // `
        //<div style="position: absolute; top: 0px;  width:2px; text-align: center; color: #000; z-index: 99999; border-right: 2px solid #000; height: 100%;left: ` + _leftTimeRel + `%; title="` + _title + `"></div>
        //<div style="position: absolute; top: calc(100% - 20px);  width: 40px; text-align: center; color: #000; z-index: 99999;height: 100%;left: calc(` + _leftTimeRel + `% - 19px);font-size: 14px;" title="` + _title + `">` + _icon + `</div>

      }

      var _countWidth = 0
      for (var i = 0; i < _dataDT.length; i++) {
        if (i == _dataDT.length - 1) {
          date2 = moment(_dataDT[i].dt).format('YYYY-MM-DD ' + this.nowTime)
          var _tmpTime = moment(date2).format('HH:mm:ss')
          var _timeSec = moment.duration(_tmpTime).asSeconds()
          var start = moment(_dataDT[0].dt, "YYYY-MM-DD");
          var end = moment(_dataDT[i].dt, "YYYY-MM-DD");
          var _diffdays = moment.duration(end.diff(start)).asDays();
          if (_diffdays == 0) {
            var start1 = moment(this.startDate, "YYYY-MM-DD");
            var end1 = moment(this.endDate, "YYYY-MM-DD");
            _diffdays = moment.duration(end1.diff(start1)).asDays();
          }
          //if (moment(_dataDT[i - 1].dt).format('YYYY-MM-DD') != moment(_dataDT[i].dt).format('YYYY-MM-DD')) {
          if (_diffdays > 0) {
            _timeSec = moment.duration(_tmpTime).asSeconds() + ((24 * _diffdays) * 60 * 60)
          }
        } else {
          var _tmpTime = moment(_dataDT[i + 1].dt).format('HH:mm:ss')
          var _timeSec = moment.duration(_tmpTime).asSeconds()
          var start = moment(_dataDT[0].dt, "YYYY-MM-DD");
          var end = moment(_dataDT[i + 1].dt, "YYYY-MM-DD");
          var _diffdays = moment.duration(end.diff(start)).asDays();
          //if (moment(_dataDT[i - 1].dt).format('YYYY-MM-DD') != moment(_dataDT[i].dt).format('YYYY-MM-DD')) {
          if (_diffdays > 0) {
            _timeSec = moment.duration(_tmpTime).asSeconds() + (24 * _diffdays * 60 * 60)
          }
        }
        //debugger
        //loso e na prelaz 11ti i 12ti radi ova gore
        var _width = (_timeSec / (_totalsec / 100)) - _countWidth
        _countWidth += _width

        var _color;
        var _height;
        var _border;
        var _txtcolor = 'transparent';
        var _activity;
        var _none = 1;

        //if (this._dataAct[i] == '-1') { _activity = ''; _color = 'rgba(255, 255, 255, 1)'; _border = 'rgb(255, 255, 255)'; _txtcolor = '#fff'; _height = 100; }
        if (_dataAct[i].act == '0') { _none = 0; _activity = this.dic.l["tachodescC0"]; _color = 'rgba(152, 229, 221, 0.5)'; _border = 'rgb(152, 229, 221)'; _txtcolor = '#1f7a71'; _height = 25; }
        if (_dataAct[i].act == '1') { _none = 0; _activity = this.dic.l["tachodescC1"]; _color = 'rgba(233, 249, 65, 0.5)'; _border = 'rgb(233, 249, 65)'; _txtcolor = '#999900'; _height = 50; }
        if (_dataAct[i].act == '2') { _none = 0; _activity = this.dic.l["tachodescC2"]; _color = 'rgba(247, 169, 12, 0.4)'; _border = 'rgb(247, 169, 12)'; _txtcolor = '#b36b00'; _height = 75; }
        if (_dataAct[i].act == '3') { _none = 0; _activity = this.dic.l["tachodescC3"]; _color = 'rgba(255, 0, 0, 0.5)'; _border = 'rgb(255, 0, 0)'; _txtcolor = '#800000'; _height = 100; }
        if (_dataAct[i].act == '6') { _none = 0; _activity = this.dic.l["tachodescC6"]; _color = 'rgba(128, 64, 0, 0.5)'; _border = 'rgb(128, 64, 0)'; _txtcolor = '#804000'; _height = 25; }
        if (_dataAct[i].act == '7') { _none = 0; _activity = this.dic.l["tachodescC7"]; _color = 'rgba(128, 128, 255, 0.5)'; _border = 'rgb(128, 128, 255)'; _txtcolor = '#0000b3'; _height = 25; }

        if (_none == 0) {
          if (_dataAct[i].drivercard == '#1') _activity += ' (' + this.dic.l["driver1"] + ')'
          if (_dataAct[i].drivercard == '#2') _activity += ' (' + this.dic.l["driver2"] + ')'
        }

        // if(i==0)
        //   var duration = moment.duration((moment(this._dataDT[i]).format('YYYY-MM-DD 00:00:00')).diff(this._dataDT[i]));
        // else

        // startDt = '/';//moment(moment(this._dataDT[i]).format('YYYY-MM-DD 00:00:00')).format(this.gn.user.TFormat)
        //   date1 = moment(this._dataDT[i]).format('YYYY-MM-DD 00:00:00')
        //   var date2 = moment(this._dataDT[i]);
        //   var endDt = date2.format(this.gn.user.TFormat)

        //   var duration = moment.duration(date2.diff(date1));
        //   var durationH = duration.asHours();
        //   var durationM = (durationH - parseInt(durationH + '')) * 60
        //   var _durationFinal = '>'+(parseInt(durationH + '') + 'h ' + parseInt(durationM + '') + 'min');

        var date1;
        var date2;
        var startDt;
        var endDt;
        if (i == _dataDT.length - 1) {
          startDt = moment(_dataDT[i].dt).format(this.gn.user.TFormat)
          if (moment(_dataDT[i].dt).format('HH:mm:ss') == '00:00:00') {
            startDt = moment(_dataDT[i].dt1).format(this.gn.user.TFormat + ' ' + this.gn.user.DFormat)
          }
          date1 = moment(_dataDT[i].dt)
          date2 = moment(moment(_dataDT[i].dt).format('YYYY-MM-DD ' + this.nowTime))
          endDt = '/'

          var duration = moment.duration(date2.diff(date1));
          var durationH = duration.asHours();
          var durationM = (durationH - parseInt(durationH + '')) * 60
          var _durationFinal = '>' + (parseInt(durationH + '') + 'h ' + parseInt(durationM + '') + 'min');
        } else {
          startDt = moment(_dataDT[i].dt).format(this.gn.user.TFormat)
          date1 = moment(_dataDT[i].dt)
          date2 = moment(_dataDT[i + 1].dt);
          endDt = date2.format(this.gn.user.TFormat)

          var duration = moment.duration(date2.diff(date1));
          var durationH = duration.asHours();
          var durationM = (durationH - parseInt(durationH + '')) * 60
          if (i == 0 && moment(_dataDT[i].dt).format('HH:mm:ss') == '00:00:00') {
            startDt = moment(_dataDT[i].dt1).format(this.gn.user.TFormat + ' ' + this.gn.user.DFormat)
            var _durationFinal = '>' + (parseInt(durationH + '') + 'h ' + parseInt(durationM + '') + 'min');
          } else {
            var _durationFinal = (parseInt(durationH + '') + 'h ' + parseInt(durationM + '') + 'min');
          }

          //if (i == 0) _durationFinal = '&nbsp;'
        }
        var _titlediv = ''
        var _vis = 'hidden'
        if (_width > 4.8 && !ismobile) _vis = 'visible'
        if (_none == 0) _titlediv = _activity + '&#13;' + this.dic.l["start"] + ': ' + startDt + '&#13;' + this.dic.l["end"] + ': ' + endDt + '&#13;' + this.dic.l["Duration"] + ': ' + _durationFinal
        _html += '<div style="width:' + _width + '%; height:' + _height + '%; border: 0px solid ' + _border + '; border-width: 0px 0px 0px 0px; background-color:' + _color + '; top: ' + (100 - _height) + '%; float: left; position: relative; text-align: center; font-size:10px; color: #000;" title="' + _titlediv + '"><div style="position: relative; top: calc(100% - 25px); min-width: 30px; text-align: center; color: ' + _txtcolor + '; z-index: 99997; visibility: ' + _vis + '">' + _dataAct[i].drivercard + '</div><div style="position: relative; top: calc(100% - 25px); min-width: 30px; text-align: center; color: ' + _txtcolor + '; z-index: 99997; visibility: ' + _vis + '">' + _durationFinal + '</div></div>'
      }
      //red ff0000
      //blue 98e5dd
      //yellow e9f941
      //orange f7860c

      areaCanvas.innerHTML = _html
    }
  }

  createXLS() {
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/pages/mapview/tachogramlive/tachogramlive.ts